/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Pdf/view.blocks to change it.
import React from 'react'
import SentryErrorBoundary from 'DesignSystem/SentryErrorBoundary/react'
import SuspenseBoundary from 'DesignSystem/SuspenseBoundary/index'
import styles from './view.module.css'
let PdfViewer = React.lazy(() => import('DesignSystem/PdfViewer/react'))



/** @type {import('Simple/types.js').View} */
export default function Pdf({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/Contracts/Content/Payor/Content/Preview/Pdf",
  presignedUrl
  
}) {
  return (<React.Fragment
>
<SentryErrorBoundary
  viewPath={`${viewPath}/SentryErrorBoundary`}
>
{childProps => (
<SuspenseBoundary
{...childProps}
  viewPath={`${viewPath}/SuspenseBoundary`}
>
{childProps => (
<div
  data-testid="Pdf.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<PdfViewer
  viewPath={`${viewPath}/PdfViewer`}
 url={presignedUrl}
/>
</div>
)}
</SuspenseBoundary>
)}
</SentryErrorBoundary>
{children}
</React.Fragment>)
}